import { useCallback } from 'react'
import { useSearch } from '../../hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'
import { FilterRequirementsAutocomplete } from '../baseInputTypes/FilterRequirementsAutocomplete'

export const EmissionTiers = () => {
  const { selectors } = useSearch()
  const searchParams = useAppSelector(selectors.selectNextSearchParameters)

  const checkIfNoIndustry = useCallback(
    () =>
      Object.values(searchParams.industries).every(
        (industry) => industry === false,
      ),
    [searchParams.industries],
  )

  return (
    <FilterRequirementsAutocomplete
      label="Emission Tiers"
      fieldName="emissionTiers"
      fieldPath={'productInformation.emissionTiers'}
      requirementOverride={checkIfNoIndustry}
    />
  )
}
